// Clé = Ce que GitHub renvoie (en minuscule)
// Valeur = Le nom EXACT du dossier sur https://devicon.dev/
const MAPPINGS = {
  // --- LANGAGES ---
  'vue': 'vuejs',
  'vue.js': 'vuejs',
  'vuejs': 'vuejs',
  'react': 'react',
  'reactjs': 'react',
  'react.js': 'react',
  'angular': 'angular',
  'angularjs': 'angularjs',
  'node': 'nodejs',
  'node.js': 'nodejs',
  'nodejs': 'nodejs',
  'c++': 'cplusplus',
  'cpp': 'cplusplus',
  'c#': 'csharp',
  'cs': 'csharp',
  'csharp': 'csharp',
  'html': 'html5',
  'html5': 'html5',
  'css': 'css3',
  'css3': 'css3',
  'js': 'javascript',
  'javascript': 'javascript',
  'ts': 'typescript',
  'typescript': 'typescript',
  'py': 'python',
  'python': 'python',
  'java': 'java',
  'rb': 'ruby',
  'ruby': 'ruby',
  'go': 'go',
  'golang': 'go',
  'php': 'php',
  'rust': 'rust',
  'swift': 'swift',
  'kotlin': 'kotlin',
  'dart': 'dart',
  'flutter': 'flutter',
  'scala': 'scala',
  'perl': 'perl',
  'lua': 'lua',
  'r': 'r',
  'haskell': 'haskell',
  'elixir': 'elixir',
  'clojure': 'clojure',
  'powershell': 'powershell',
  // --- OUTILS & FRAMEWORKS ---
  'spring': 'spring',
  'spring-boot': 'spring',
  'springboot': 'spring',
  'laravel': 'laravel',
  'symfony': 'symfony',
  'django': 'django',
  'flask': 'flask',
  'fastapi': 'fastapi',
  'dot-net': 'dot-net',
  '.net': 'dot-net',
  'dotnet': 'dot-net',
  'bootstrap': 'bootstrap',
  'tailwind': 'tailwindcss',
  'tailwindcss': 'tailwindcss',
  'sass': 'sass',
  'less': 'less',
  'mysql': 'mysql',
  'sql': 'mysql', // Fallback générique
  'postgres': 'postgresql',
  'postgresql': 'postgresql',
  'mongo': 'mongodb',
  'mongodb': 'mongodb',
  'sqlite': 'sqlite',
  'redis': 'redis',
  'firebase': 'firebase',
  'git': 'git',
  'github': 'github',
  'docker': 'docker',
  'bash': 'bash',
  'shell': 'bash',
  'linux': 'linux',
  'ubuntu': 'ubuntu',
  'windows': 'window11', 
  'android': 'android',
  'apple': 'apple',
  'aws': 'amazonwebservices',
  'azure': 'azure',
  'gcp': 'googlecloud',
  'heroku': 'heroku',
  'netlify': 'netlify',
  'vercel': 'vercel',
  'npm': 'npm',
  'yarn': 'yarn',
  'vscode': 'vscode',
  'idea': 'intellij',
  'intellij': 'intellij',
  'eclipse': 'eclipse',
  'arduino': 'arduino',
  'unity': 'unity',
  'godot': 'godot',
  'blender': 'blender',
  'figma': 'figma',
  'jest': 'jest',
  'mocha': 'mocha',
  'junit': 'junit',
  'selenium': 'selenium',
}

export const getIconName = (techName) => {
  if (!techName) return null
  
  // 1. Nettoyage de base (minuscule + trim)
  const normalized = techName.toLowerCase().trim()
  
  // 2. Recherche dans le mapping manuel (Priorité absolue)
  if (MAPPINGS[normalized]) {
    return MAPPINGS[normalized]
  }
  
  // 3. Si pas trouvé, on essaie de nettoyer les caractères spéciaux
  // Ex: "user-auth" devient "userauth", ce qui marche parfois
  return normalized.replace(/[^a-z0-9]/g, '')
}